import { BILLING_GET_INFO } from '../constants';
import { billingXMLGetRequest } from '@ertelecom/ui-react/components/requests/billingRequest';
import profileRequest from '@ertelecom/ui-react/components/requests/profileRequest';
import serviceUserRequest from '@ertelecom/ui-react/components/requests/serviceUserRequest';
import { dataLayerForCPA } from '~/src/helpers/eventsForDataLayer';
import { EPriceOperationTypes, EPriceTypes } from '~/src/models/price';
import { sortFunction } from '~/src/helpers/functions';

const GET_ROUTER_INFO = 'get_router_info';

export const authEquipRequest = (domain, params, accessToken) => {
    params.accessToken = accessToken;
    return serviceUserRequest(domain)
        .get('/create-router-request', { params })
        .then(res => {
            res.status = 1;
            dataLayerForCPA(res.data);
            return res;
        })
        .catch(res => {
            if (res.request.response) {
                const result = JSON.parse(res.request.response);
                result.status = 0;
                return result;
            }
        });
};

/**
 * Закрытие рассрочки оборудования досрочное
 * @param {String} domain
 * @param {String} activityId
 */
export const closeLeasing = (domain, accessToken, activityId) => {
    return profileRequest(domain, accessToken).post('/equipment/close-leasing', {
        activityId,
    }).then(response => {
        return response.data;
    }).catch(error => {
        throw Error(error.response?.data?.message || error.message);
    });
};

export const getUserRouterInfo = (domain, accessToken) => {
    const jsonParam = {
        attributePrefix: '',
    };

    return billingXMLGetRequest(domain, accessToken, BILLING_GET_INFO, GET_ROUTER_INFO, null, jsonParam).then(res => {
        if (res?.data) {
            return res.data.get_router_info.rowset;
        }
        return false;
    });
};

/**
 * @param {string} domain
 * @param {string} accessToken
 * @return {Promise<unknown>}
 */
export const getUserTvInfo = (domain, accessToken) => {
    const jsonParam = {
        attributePrefix: '',
    };
    return billingXMLGetRequest(domain, accessToken, BILLING_GET_INFO, 'get_domrutv_equip_info', null, jsonParam).then(res => {
        if (res?.data) {
            const data = res.data.get_domrutv_equip_info.rowset.row;
            if (data) {
                return data.length ? data : [data];
            }
        }
        return false;
    });
};

export const convertPrice = (item, domain) => {
    const res = [];
    if (item.leasingDuration && item.leasingPrice || item.leasing_dur && item.leasing_mon_price) {
        res.push({
            value: item.leasingDuration || item.leasing_dur,
            label: `Рассрочка ${item.leasingDuration || item.leasing_dur} мес.`,
            price: item.leasingPrice || item.leasing_mon_price,
            type: EPriceTypes.Leasing,
        });
    }

    if (item.leasingDurationSec && item.leasingPriceSec || item.leasing_dur_two && item.leasing_mon_price_two) {
        res.push({
            value: item.leasingDurationSec || item.leasing_dur_two,
            label: `Рассрочка ${item.leasingDurationSec || item.leasing_dur_two} мес.`,
            price: item.leasingPriceSec || item.leasing_mon_price_two,
            type: EPriceTypes.Leasing,
        });
    }

    if (item.posessPrice || item.posess_price) {
        const insert = {
            value: 0,
            label: 'Покупка',
            price: item.posessPrice || item.posess_price,
            type: EPriceTypes.Possess,
        };

        if ('ekat' === domain) {
            res.unshift(insert);
        } else {
            res.push(insert);
        }
    }
    return res;
};

export const convertDevicePrices = (device) => {
    if (!device) {
 return [];
}

    const {
        posessPrice,
        posess_price,
        promo,
        leasing,
        leasingDuration,
        leasingPrice,
        leasing_dur,
        leasing_mon_price,
        leasingDurationSec,
        leasingPriceSec,
        leasing_dur_two,
        leasing_mon_price_two,
    } = device;

    const prices = [];

    if (posessPrice || posess_price) {
        prices.push({
            type: EPriceTypes.Possess,
            value: posessPrice || posess_price,
            valuePromo: promo,
        });
    }

    if (Array.isArray(leasing)) {
        leasing.forEach(leasingPriceItem => {
            prices.push({
                type: EPriceTypes.Leasing,
                value: leasingPriceItem.price,
                duration: leasingPriceItem.duration,
            });
        });
    } else {
        if (leasingDuration && leasingPrice || leasing_dur && leasing_mon_price) {
            prices.push({
                type: EPriceTypes.Leasing,
                value: leasingPrice || leasing_mon_price,
                duration: leasingDuration || leasing_dur,
            });
        }

        if (leasingDurationSec && leasingPriceSec || leasing_dur_two && leasing_mon_price_two) {
            prices.push({
                type: EPriceTypes.Leasing,
                value: leasingPriceSec || leasing_mon_price_two,
                duration: leasingDurationSec || leasing_dur_two,
            });
        }
    }

    return prices;
};

export const getPriceOptions = (prices, domain) => {
    const options = [];
    let hasNonEmptySortField = false;

    prices.filter(item => item.type === EPriceTypes.Leasing)
        .sort((item1, item2) => item2.duration - item1.duration)
        .forEach(item => {
            options.push({
                value: item.duration,
                label: `Рассрочка на ${item.duration} мес.`,
                price: item.value,
                pricePromo: item.valuePromo,
                type: EPriceTypes.Leasing,
                operType: EPriceOperationTypes.Leasing,
                sort: item.sort
            });

            if (item.sort) {
                hasNonEmptySortField = true;
            }
        });

    prices.filter(item => item.type === EPriceTypes.Possess)
        .forEach(item => {
            const priceItem = {
                value: 0,
                label: 'Покупка',
                price: item.value,
                pricePromo: item.valuePromo,
                type: EPriceTypes.Possess,
                operType: EPriceOperationTypes.Possess,
                sort: item.sort
            };

            if (item.sort) {
                hasNonEmptySortField = true;
            }

            if ('ekat' === domain) {
                options.unshift(priceItem);
            } else {
                options.push(priceItem);
            }
        });

    if (hasNonEmptySortField) {
        options.sort(sortFunction);
    }

    return options;
};
